export default __webpack_public_path__ + "static/media/fi.3b522e7f.svg";